import { PRINTER_STATUS } from "common/screens/modalComponents/cloudPrint/types/CloudPrintTypes"
import { ISseStandardEvent } from "common/services/sse/Sse"

export interface ICloudPrinterStatusWithDetails {
    printerState: string
    printerStateMessage?: string
    printerStateReasons?: string
}

export enum CLOUD_PRINTER_ATTRIBUTES {
    COLOR_MODE = "print-color-mode",
    COLOR_MODE_SUPPORTED = "print-color-mode-supported",
    COPIES = "copies",
    COPIES_SUPPORTED = "copies-supported",
    ORIENTATION = "orientation-requested",
    ORIENTATION_SUPPORTED = "orientation-requested-supported",
    PAPER_SIZE = "media",
    PAPER_SIZE_SUPPORTED = "media-ready",
    PRINT_QUALITY = "print-quality",
    PRINT_QUALITY_SUPPORTED = "print-quality-supported",
    SIDES = "sides",
    SIDES_SUPPORTED = "sides-supported",
}

interface ICloudPrinterBaseAttribute {
    enable: boolean
}

interface ICloudPrinterColorModeAttribute extends ICloudPrinterBaseAttribute {
    [CLOUD_PRINTER_ATTRIBUTES.COLOR_MODE_SUPPORTED]?: string[]
}

interface ICloudPrinterCopiesAttribute extends ICloudPrinterBaseAttribute {
    [CLOUD_PRINTER_ATTRIBUTES.COPIES_SUPPORTED]?: number[]
}

interface ICloudPrinterOrientationAttribute extends ICloudPrinterBaseAttribute {
    [CLOUD_PRINTER_ATTRIBUTES.ORIENTATION_SUPPORTED]?: string[]
}

interface ICloudPrinterPaperSizeAttribute extends ICloudPrinterBaseAttribute {
    [CLOUD_PRINTER_ATTRIBUTES.PAPER_SIZE_SUPPORTED]?: string[]
}

interface ICloudPrinterPrintQualityAttribute extends ICloudPrinterBaseAttribute {
    [CLOUD_PRINTER_ATTRIBUTES.PRINT_QUALITY_SUPPORTED]?: string | string[]
}

interface ICloudPrinterSidesAttribute extends ICloudPrinterBaseAttribute {
    [CLOUD_PRINTER_ATTRIBUTES.SIDES_SUPPORTED]?: string[]
}

export interface ICloudPrinterAttributes {
    [CLOUD_PRINTER_ATTRIBUTES.COLOR_MODE]: ICloudPrinterColorModeAttribute
    [CLOUD_PRINTER_ATTRIBUTES.COPIES]: ICloudPrinterCopiesAttribute
    [CLOUD_PRINTER_ATTRIBUTES.ORIENTATION]: ICloudPrinterOrientationAttribute
    [CLOUD_PRINTER_ATTRIBUTES.PAPER_SIZE]: ICloudPrinterPaperSizeAttribute
    [CLOUD_PRINTER_ATTRIBUTES.PRINT_QUALITY]: ICloudPrinterPrintQualityAttribute
    [CLOUD_PRINTER_ATTRIBUTES.SIDES]: ICloudPrinterSidesAttribute
}

export interface ICloudPrintingOptions {
    docPagesNumber: number
    printAllPages: boolean
    [CLOUD_PRINTER_ATTRIBUTES.COPIES]: number
    [CLOUD_PRINTER_ATTRIBUTES.ORIENTATION]: string
    orientationDisabled: boolean
    [CLOUD_PRINTER_ATTRIBUTES.COLOR_MODE]: string
    [CLOUD_PRINTER_ATTRIBUTES.SIDES]: string
    [CLOUD_PRINTER_ATTRIBUTES.PAPER_SIZE]: string
    [CLOUD_PRINTER_ATTRIBUTES.PRINT_QUALITY]: string
    scale: "original" | "fitToPageWidth"
}

export type GetPrinterStatusAndAttributesParams =
    | {
          url: string
          printerId?: never
      }
    | {
          url?: never
          printerId: string
      }

interface IPrinterStatusAndAttributesAsyncResponse {
    printerDistinguisher: string
    printerStatusWithDetails: ICloudPrinterStatusWithDetails
    printerAttributes: ICloudPrinterAttributes
}

export type IPrinterStatusAndAttributesSseEvent =
    ISseStandardEvent<IPrinterStatusAndAttributesAsyncResponse>

export interface IStatusAndAttributes {
    printerStatus: PRINTER_STATUS
    printerStateMessage?: string
    printerStateReasons?: string
    printerAttributes?: ICloudPrinterAttributes
}

export interface ICloudPrintersStatusAndAttributes {
    [printerDistinguisher: string]: IStatusAndAttributes
}
